import React from 'react';
import './styles/Master.css';
import './styles/App.css';
import { Switch, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import Home from './components/Home';
import About from './components/About';
import Skills from './components/Skills';
import Services from './components/Services';
import Projects from './components/Projects';
import Contact from './components/Contact';
import FAQs from './components/FAQs';
import Footer from './components/Footer';

const wallVariants = {
	initial: {
		height: '100%',
	},
	animate: {
		height: 0,
		transition: {
			delay: 3,
			duration: 0,
		},
	},
};

const leftVariants = {
	initial: {
		left: 0,
	},
	animate: {
		left: '-50%',
		transition: {
			delay: 1,
			duration: 2,
		},
	},
};
const rightVariants = {
	initial: {
		right: 0,
	},
	animate: {
		right: '-50%',
		transition: {
			delay: 1,
			duration: 2,
		},
	},
};

function App() {
	document.ondragstart = (e) => e.preventDefault();
	document.ondragover = (e) => e.preventDefault();
	document.oncontextmenu = (e) => e.preventDefault();
	(function cleanup() {
		//console.clear();
		window.setTimeout(cleanup, 500);
	})();

	return (
		<React.Fragment>
			<Switch>
				<Route path="/home" component={Home} />
				<Route path="/about" component={About} />
				<Route path="/skills" component={Skills} />
				<Route path="/services" component={Services} />
				<Route path="/projects" component={Projects} />
				<Route path="/contact" component={Contact} />
				<Route path="/faqs" component={FAQs} />
				<Route path="/" component={Home} />
			</Switch>
			<Footer />
			<motion.div variants={wallVariants} initial="initial" animate="animate" className="wall">
				<motion.div variants={leftVariants} className="door l-door">
					<div className="logo-frame">
						<section className="logo"></section>
					</div>
				</motion.div>
				<motion.div variants={rightVariants} className="door r-door">
					<div className="logo-frame">
						<section className="logo"></section>
					</div>
				</motion.div>
			</motion.div>
		</React.Fragment>
	);
}

export default App;
